import React, { PureComponent } from "react";
import AsyncReactSelect from "react-select/async";

class Select extends PureComponent {
	render() {
		const { props } = this;

		return (
			<AsyncReactSelect {...props /* eslint-disable-line react/jsx-props-no-spreading */} />
		);
	}
}

export default Select;
